import React, { memo, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '~/store';
import {
  clanTasksClaimedSelector,
  clanTasksIsClaimingSelector,
  clanTasksIsFetchingSelector,
  clanTasksTasksSelector,
} from '~/store/selectors/clanTasksSelectors';
import { currentAccountSelector } from '~/store/selectors/currentAccountSelector';
import { claimClanTasksThunk, claimClanTaskThunk, getClanTasksThunk } from '~/Actions/ActionClanTasks';

import ViewClanTasks from '~/Components/ViewClanTasks/ViewClanTasks';

const ContainerClanTasks: React.FC = () => {
  const dispatch = useAppDispatch();

  const currentAccount = useSelector(currentAccountSelector);
  const isClaiming = useSelector(clanTasksIsClaimingSelector);
  const isFetching = useSelector(clanTasksIsFetchingSelector);
  const claimed = useSelector(clanTasksClaimedSelector);
  const tasks = useSelector(clanTasksTasksSelector);

  useEffect(() => {
    dispatch(getClanTasksThunk());
  }, [dispatch]);

  const claimClanTask = (taskId: number) => {
    dispatch(claimClanTaskThunk(taskId));
  };

  const claimClanTasks = () => {
    dispatch(claimClanTasksThunk());
  };

  return (
    <ViewClanTasks
      claimClanTask={claimClanTask}
      claimClanTasks={claimClanTasks}
      claimed={claimed}
      currentAccount={currentAccount}
      isClaiming={isClaiming}
      isFetching={isFetching}
      tasks={tasks}
    />
  );
};

export default memo(ContainerClanTasks);
